export default {
  "about": "Uber uns",
  "about_title": "Über uns",
  "access_secret": "Zugriffsgeheimnis",
  "access_token": "Zugriffstoken",
  "accessibility_animations": "Animationen",
  "accessibility_contrast": "Kontrast",
  "accessibility_font_size": "Schriftgröße",
  "accessibility_title": "Barrierefreiheit",
  "actions": "Aktionen",
  "active": "Aktiv",
  "active_ads": "Aktive Anzeigen",
  "active_campaigns": "Aktive Kampagnen",
  "ad_code_placeholder": "<script>...</script> oder AdSense-Slot-Code",
  "ad_format": "Anzeigenformat",
  "ad_formats": "Anzeigenformate",
  "ad_management": "Anzeigenverwaltung",
  "ad_position_settings": "Einstellungen der Anzeigenposition",
  "ad_price_list": "Preisliste für Anzeigen",
  "ad_pricing_formats_campaigns": "Preise, Formate, Kampagnen und Tracking",
  "add": "Hinzufügen",
  "add_api_keys": "API-Schlüssel im Konfigurationstab hinzufügen",
  "address": "Adresse",
  "admin": "Admin",
  "adminPanel": "Admin-Bereich",
  "admin_ab_testing_title": "A/B-Test",
  "admin_accent": "Akzent",
  "admin_accent_color": "Akzentfarbe",
  "admin_action": "Aktion",
  "admin_activate": "Aktivieren",
  "admin_active_feeds": "Aktive Feeds",
  "admin_active_label": "AKTIV",
  "admin_active_now": "Jetzt aktiv",
  "admin_active_subscribers": "Aktive Abonnenten",
  "admin_ad_performance": "Anzeigenleistung",
  "admin_add_feed": "Feed hinzufügen",
  "admin_add_tag": "Tag hinzufügen",
  "admin_admins": "Admins",
  "admin_advertisements": "Werbungen",
  "admin_advertiser_email": "E-Mail des Werbetreibenden",
  "admin_advertiser_name": "Name des Werbetreibenden",
  "admin_affiliate_links": "Affiliate-Links",
  "admin_ai_content_title": "KI-Inhaltsverarbeitung",
  "admin_ai_prompt_settings": "KI-Eingabeaufforderung & Modell-Einstellungen",
  "admin_analytics_title": "Analytik",
  "admin_api_latency": "API-Latenz",
  "admin_api_server": "API-Server",
  "admin_article_actions": "Aktionen",
  "admin_article_category": "Kategorie",
  "admin_article_published": "Veröffentlicht",
  "admin_article_selector": "Artikelselektor (CSS, z.B. article.news)",
  "admin_article_views": "Ansichten",
  "admin_articles_count": "Artikel",
  "admin_articles_title": "Artikel",
  "admin_author_change_failed": "Autorenänderung fehlgeschlagen.",
  "admin_authors_title": "Autoren",
  "admin_auto": "AUTO",
  "admin_auto_save_draft": "Automatisch als Entwurf speichern",
  "admin_avg_seo_score": "Durchschn. SEO-Bewertung",
  "admin_bio": "Biografie",
  "admin_blog_manage": "Blog-Beiträge mit reichhaltigem Inhaltseditor verwalten",
  "admin_blog_title": "Blog",
  "admin_brand_theme": "Marke & Thema",
  "admin_branding_desc": "Website-Erscheinungsbild anpassen (nur Systemadministrator)",
  "admin_branding_title": "Rebranding-Modul",
  "admin_breaking_ticker": "Eilmeldungs-Ticker",
  "admin_browser": "Browser",
  "admin_browsers": "Browser",
  "admin_bug_reports": "Fehlerberichte",
  "admin_bulk_delete_failed": "Massenlöschung fehlgeschlagen.",
  "admin_bulk_operations": "Massenoperationen",
  "admin_categories_grid": "Kategorienraster",
  "admin_choose_gallery": "Aus Galerie wählen",
  "admin_churn_prediction": "Kündigungsvorhersage",
  "admin_classic_portal": "Klassisches Nachrichtenportal",
  "admin_classifieds": "Kleinanzeigen",
  "admin_clear_log": "Protokoll löschen",
  "admin_click_button": "Klicken Sie auf die Schaltfläche",
  "admin_collection_stats": "Sammlungsstatistiken",
  "admin_color_scheme": "Farbschema",
  "admin_columnist": "Kolumnist",
  "admin_comments": "Kommentare",
  "admin_competitor_monitoring": "Wettbewerbsüberwachung",
  "admin_confirm_action": "Sind Sie sicher?",
  "admin_content_calendar_title": "Inhaltskalender",
  "admin_content_filter": "Inhaltsfilter Begriffe",
  "admin_content_stats": "Inhaltsstatistiken",
  "admin_contributor": "Mitwirkender",
  "admin_coordinates": "Koordinaten",
  "admin_copy_ip": "IP-Adresse kopieren",
  "admin_copy_text": "Kopieren",
  "admin_core_services": "Kernservices",
  "admin_countries": "Länder",
  "admin_cpc": "CPC (EUR)",
  "admin_crawl_now": "Jetzt crawlen",
  "admin_create_author": "Autor erstellen",
  "admin_create_manage_promo": "Werbecodes erstellen und verwalten",
  "admin_create_voucher": "Gutschein erstellen",
  "admin_custom_meta": "Benutzerdefiniertes Meta",
  "admin_dashboard_title": "Dashboard",
  "admin_database": "Datenbank",
  "admin_db_backup": "Datenbanksicherung",
  "admin_db_latency": "DB-Latenz",
  "admin_db_name": "Datenbankname",
  "admin_db_size": "DB-Größe",
  "admin_default": "STANDARD",
  "admin_default_language": "Standardsprache",
  "admin_device": "Gerät",
  "admin_devices": "Geräte",
  "admin_discount": "Rabatt",
  "admin_disk_usage": "Festplattennutzung",
  "admin_docs_api_ref": "API-Referenz",
  "admin_docs_download_pdf": "PDF herunterladen",
  "admin_docs_faq": "FAQ",
  "admin_docs_getting_started": "Erste Schritte",
  "admin_docs_implemented": "Implementiert",
  "admin_docs_no_pages": "Noch keine Dokumentationsseiten",
  "admin_docs_order": "Reihenfolge",
  "admin_docs_title": "Dokumentation",
  "admin_doktor_earnings": "Doktor Einnahmen",
  "admin_draft_articles": "Entwurfsartikel",
  "admin_dynamic_pricing": "Dynamische Preisgestaltung",
  "admin_edit_in_cms": "Im CMS bearbeiten",
  "admin_editor_role": "Redakteur",
  "admin_export_csv": "CSV exportieren",
  "admin_favicon": "Favicon",
  "admin_feed_crawler": "Feed-Crawler",
  "admin_feed_name": "Feed-Name",
  "admin_feed_url": "Feed-URL",
  "admin_feeds_title": "RSS-Feeds",
  "admin_file": "Datei",
  "admin_fixed_amount": "Fester Betrag",
  "admin_frozen": "Eingefroren",
  "admin_full_name": "Vollständiger Name",
  "admin_general": "Allgemein",
  "admin_google_search_console": "Google Search Console",
  "admin_grade": "Note",
  "admin_health_title": "Systemprüfung",
  "admin_high_leads": "Hochwertige Leads",
  "admin_import_title": "Croatia Times Importplattform",
  "admin_index_now": "IndexNow",
  "admin_integrations": "Integrationen",
  "admin_job_postings": "Stellenanzeigen",
  "admin_joined": "Beigetreten",
  "admin_keywords": "Schlüsselwörter",
  "admin_landing_title": "Landing Pages",
  "admin_last_submissions": "Letzte Einreichungen",
  "admin_live_analytics": "Live-Analysen",
  "admin_live_analytics_title": "Live-Analytik",
  "admin_llm_model": "LLM-Modell",
  "admin_manage_feeds": "Feeds verwalten",
  "admin_mass_management": "Massenartikelverwaltung",
  "admin_max_articles": "Max. Artikel",
  "admin_media_storage": "Medienarchiv",
  "admin_memory": "Speicher",
  "admin_menu_manager": "Menü-Manager",
  "admin_meta_description": "Meta-Beschreibung",
  "admin_monetization_title": "Monetarisierungs-Dashboard",
  "admin_mysql_db": "MySQL-Datenbank",
  "admin_mysql_host": "MySQL-Host",
  "admin_nav_ab_testing": "A/B-Tests",
  "admin_nav_ads": "Anzeigenverwaltung",
  "admin_nav_ads_report": "Anzeigenbericht",
  "admin_nav_adsense": "AdSense-Einstellungen",
  "admin_nav_advanced_analytics": "Erweiterte Analysen",
  "admin_nav_affiliates": "Affiliate-Links",
  "admin_nav_ai_content": "KI-Inhaltsverarbeitung",
  "admin_nav_amp": "AMP & Google Discover",
  "admin_nav_analytics": "Analysen",
  "admin_nav_analytics_ai": "Analysen & KI",
  "admin_nav_articles": "Artikel",
  "admin_nav_audit_log": "Prüfprotokoll",
  "admin_nav_authors": "Autoren",
  "admin_nav_blog": "Blog",
  "admin_nav_branding": "Rebranding",
  "admin_nav_breaking_news": "Eilmeldungen / Blitznachrichten",
  "admin_nav_bulk_operations": "Massenoperationen",
  "admin_nav_categories": "Kategorien",
  "admin_nav_chat_sessions": "Chat-Sitzungen",
  "admin_nav_churn_prediction": "Wechselprognose",
  "admin_nav_classifieds": "Kleinanzeigen",
  "admin_nav_comments": "Kommentare",
  "admin_nav_competitor_monitoring": "Wettbewerbsüberwachung",
  "admin_nav_content": "Inhalte",
  "admin_nav_content_calendar": "Inhaltskalender",
  "admin_nav_county_map": "Landkreiskarte",
  "admin_nav_crypto": "Krypto-Widget",
  "admin_nav_dashboard": "Dashboard",
  "admin_nav_db_backup": "Datenbank",
  "admin_nav_docs": "Dokumentation",
  "admin_nav_doktor_earnings": "Doktor-Einnahmen",
  "admin_nav_duplicate_detection": "Doppelterkennung",
  "admin_nav_editorial": "Redaktion",
  "admin_nav_editorial_workflow": "Redaktioneller Workflow",
  "admin_nav_email_campaigns": "E-Mail-Kampagnen",
  "admin_nav_feeds": "RSS-Feeds",
  "admin_nav_finance": "Finanzen",
  "admin_nav_health": "Systemzustand",
  "admin_nav_heatmaps": "Lese-Heatmap",
  "admin_nav_import": "Importieren",
  "admin_nav_invoices": "Rechnungen",
  "admin_nav_job_ads": "Stellenanzeigen",
  "admin_nav_landing_pages": "Landing Pages",
  "admin_nav_live_analytics": "Live-Analysen",
  "admin_nav_management": "Verwaltung",
  "admin_nav_marketing": "Marketing",
  "admin_nav_media": "Medien",
  "admin_nav_menu_manager": "Menüverwaltung",
  "admin_nav_micropayments": "Mikrozahlungen",
  "admin_nav_monetization": "Monetarisierung",
  "admin_nav_newsletter": "Newsletter",
  "admin_nav_newsletter_digest": "Newsletter-Übersicht",
  "admin_nav_pages": "Seiten",
  "admin_nav_payments": "Zahlungen",
  "admin_nav_performance_forecast": "Leistungsprognose",
  "admin_nav_photo_verification": "Fotoüberprüfung",
  "admin_nav_portal_toggle": "Portalverwaltung",
  "admin_nav_portals": "Portale",
  "admin_nav_pricing": "Preisgestaltung",
  "admin_nav_promo_codes": "Promo-Codes",
  "admin_nav_push_notifications": "Push-Benachrichtigungen",
  "admin_nav_quizzes": "Quizze",
  "admin_nav_recommendations": "Inhaltsempfehlungen",
  "admin_nav_reports": "Inhaltsberichte",
  "admin_nav_sanitization": "Inhaltsbereinigung",
  "admin_nav_scheduler": "Inhaltsplaner",
  "admin_nav_security": "Sicherheit",
  "admin_nav_seo_dashboard": "SEO-Dashboard",
  "admin_nav_seo_distribution": "SEO & Verteilung",
  "admin_nav_series": "Artikelserien",
  "admin_nav_settings": "Einstellungen",
  "admin_nav_social": "Soziale Medien",
  "admin_nav_social_scheduler": "Sozialer Planer",
  "admin_nav_sponsored": "Gesponsert",
  "admin_nav_sponsored_marketplace": "Sponsor-Marktplatz",
  "admin_nav_subscriptions": "Abonnements",
  "admin_nav_surveys": "Umfragen",
  "admin_nav_syndication": "Syndication-API",
  "admin_nav_system": "System",
  "admin_nav_tips": "Trinkgelder / Spenden",
  "admin_nav_translations": "Übersetzungen",
  "admin_nav_ugc_review": "Bürgerinhalte",
  "admin_nav_users": "Benutzer",
  "admin_nav_users_subscriptions": "Benutzer & Abonnements",
  "admin_nav_versioning": "Versionsgeschichte",
  "admin_nav_vibeposao": "Times Posao Portal",
  "admin_nav_vouchers": "Gutscheine / Rabatte",
  "admin_nav_widgets": "Widgets / Kataloge",
  "admin_new_author_name": "Neuer Autorenname...",
  "admin_new_post": "Neuer Beitrag",
  "admin_no_data": "Keine Daten verfügbar",
  "admin_no_icon": "Kein Icon",
  "admin_no_logo": "Kein Logo",
  "admin_no_pending_reports": "Keine ausstehenden Berichte",
  "admin_no_published_articles": "Keine veröffentlichten Artikel gefunden",
  "admin_password_field": "Passwort",
  "admin_performance_forecast": "Leistungsvorhersage",
  "admin_photo_verification": "Fotoüberprüfung",
  "admin_plan": "Plan",
  "admin_platform_audit": "Plattformprüfung",
  "admin_portal_toggle": "Portalverwaltung",
  "admin_premium_users": "Premium-Benutzer",
  "admin_primary": "Primär",
  "admin_published_articles": "Veröffentlichte Artikel",
  "admin_published_today": "Heute veröffentlicht",
  "admin_quick_actions": "Schnellaktionen",
  "admin_recent_articles": "Neueste Artikel",
  "admin_role_change_failed": "Rollenaktualisierung fehlgeschlagen.",
  "admin_search_placeholder": "Suche Admin...",
  "admin_secondary": "Sekundär",
  "admin_seo_desc": "Inhaltsoptimierung, GSC- & Sitemap-Verwaltung",
  "admin_seo_title": "SEO-Dashboard",
  "admin_service_requests": "Serviceanfragen",
  "admin_set_category": "Kategorie festlegen",
  "admin_set_featured": "Als hervorheben festlegen",
  "admin_settings_saved": "Einstellungen gespeichert",
  "admin_settings_title": "Einstellungen",
  "admin_short_desc": "Kurzbeschreibung",
  "admin_site_identity": "Website-Identität",
  "admin_site_logo": "Website-Logo",
  "admin_site_settings": "Seiteneinstellungen",
  "admin_sponsored_marketplace": "Gesponserter Marktplatz",
  "admin_sponsored_title": "Gesponserte Artikel",
  "admin_surveys_title": "Umfragen",
  "admin_system_status": "Systemstatus",
  "admin_table_header_actions": "Aktionen",
  "admin_table_header_date": "Datum",
  "admin_table_header_email": "E-Mail",
  "admin_table_header_name": "Name",
  "admin_table_header_status": "Status",
  "admin_thumbnail_settings_saved": "Thumbnail-Einstellungen gespeichert",
  "admin_top_articles_views": "Top-Artikel nach Aufrufen",
  "admin_total_articles": "Gesamtanzahl der Artikel",
  "admin_total_users": "Gesamtanzahl der Benutzer",
  "admin_total_views": "Gesamtanzahl der Ansichten",
  "admin_ugc_review": "UGC-Überprüfung",
  "admin_username": "Benutzername",
  "admin_users_title": "Benutzer",
  "admin_version_history": "Versionsverlauf",
  "admin_view_health_report": "Vollständigen Gesundheitsbericht ansehen",
  "admin_write_new_article": "Neuen Artikel schreiben",
  "adsense_client_id": "AdSense-Kunden-ID",
  "adsense_enable_disable": "Aktivieren/deaktivieren Sie alle automatischen Anzeigenplatzierungen",
  "adsense_global_toggle": "AdSense Globale Umschaltung",
  "adsense_script_code": "AdSense-Skriptcode",
  "adsense_settings": "AdSense & Anzeigenpositionen",
  "advertise_contact_sales": "Vertrieb kontaktieren",
  "advertise_get_started": "Loslegen",
  "advertise_reach_audience": "Erreichen Sie unser Publikum",
  "advertise_title": "Werben Sie mit uns",
  "advertiser": "Werbetreibender",
  "advertiser_analytics": "Werbetreibenden-Analysen",
  "advertiser_email": "E-Mail des Werbetreibenden",
  "advertising": "Werbung",
  "advertising_cookies": "Werbe-Cookies",
  "affiliate_title": "Affiliate-Programm",
  "ago": "vor",
  "ai_image_prompt": "KI-Bildaufforderung",
  "all": "Alle",
  "all_categories": "Alle Kategorien",
  "all_jobs": "Alle Stellen",
  "all_rights": "Alle Rechte vorbehalten",
  "all_status": "Alle Status",
  "all_types": "Alle Arten",
  "alpha": "Alpha",
  "alreadyHaveAccount": "Bereits ein Konto?",
  "already_have_account": "Haben Sie bereits ein Konto?",
  "analytics": "Analytik",
  "analytics_cookies": "Analyse-Cookies",
  "api_key": "API-Schlüssel",
  "api_secret": "API-Geheimnis",
  "applications": "Bewerbungen",
  "apply": "Anwenden",
  "apply_now": "Jetzt bewerben",
  "approve": "Genehmigen",
  "approved": "Genehmigt",
  "archive": "Archivieren",
  "archived": "Archiviert",
  "article_content": "Artikelinhalt",
  "article_title": "Artikeltitel...",
  "article_views": "Aufrufe",
  "author": "Autor",
  "auto_posting": "Automatisches Posten und soziale Integrationen",
  "auto_share_articles": "Veröffentlichte Artikel automatisch auf verbundenen Plattformen teilen",
  "avg_ctr": "Durchschnittlicher CTR",
  "back": "Zuruck",
  "basic": "Basis",
  "be_respectful": "Seien Sie respektvoll und höflich gegenüber anderen Benutzern und den Themen der Artikel",
  "beta": "Beta",
  "book_ad": "Anzeige buchen",
  "booking_details": "Buchungsdetails",
  "breaking": "EILMELDUNG",
  "bug_description": "Fehlerbeschreibung",
  "business": "Wirtschaft",
  "business_account_id": "Geschäftskonto-ID",
  "buyer": "Käufer",
  "campaign_details": "Kampagnendetails",
  "campaigns": "Kampagnen",
  "cancel": "Abbrechen",
  "caption": "Bildunterschrift",
  "categories": "Kategorien",
  "category": "Kategorie",
  "category_distribution": "Kategorieverteilung",
  "category_push_subscribers": "Push-Abonnenten der Kategorie",
  "chatbot_placeholder": "Nachricht eingeben...",
  "chatbot_send": "Senden",
  "chatbot_title": "Chat-Assistent",
  "choose_plan": "Plan wahlen",
  "city": "Stadt",
  "classifieds": "Kleinanzeigen",
  "classifieds_title": "Kleinanzeigen",
  "clear": "Löschen",
  "click_rate": "Klickrate",
  "click_url": "Klick-URL (Ziel)",
  "clicks": "Klicks",
  "client_id": "Kunden-ID",
  "client_secret": "Kunden-Geheimnis",
  "close": "Schliessen",
  "code": "Code",
  "commenting_rules": "Regeln für Kommentare",
  "comments": "Kommentare",
  "companies": "Unternehmen",
  "company": "Unternehmen",
  "compose_social_post": "Sozialen Beitrag verfassen",
  "configure": "Konfigurieren",
  "configure_position": "Konfigurieren Sie jede Position mit einem benutzerdefinierten Bannerbild oder Anzeigencode",
  "confirm": "Bestätigen",
  "confirm_delete": "Sind Sie sicher, dass Sie löschen möchten?",
  "confirm_password": "Passwort bestatigen",
  "congratulations": "Herzlichen Glückwunsch",
  "contact": "Kontakt",
  "contact_title": "Kontakt",
  "contact_us": "Kontaktieren Sie uns",
  "content": "Inhalt",
  "cookies": "Cookies",
  "cookies_title": "Cookie-Richtlinie",
  "copy": "Kopieren",
  "copyright": "Urheberrecht",
  "copyright_notice": "Urheberrecht",
  "count": "Anzahl",
  "country": "Land",
  "cpm": "CPM",
  "create": "Erstellen",
  "create_first_ad": "Erstellen Sie Ihre erste Anzeige",
  "crypto_change_24h": "24h Veränderung",
  "crypto_market_cap": "Marktkapitalisierung",
  "crypto_price": "Preis",
  "crypto_widget_title": "Krypto",
  "ctr": "CTR",
  "culture": "Kultur",
  "current_plan": "Aktueller Plan",
  "custom_ad_code": "Benutzerdefinierter Anzeigencode",
  "custom_banner_url": "Benutzerdefinierte Banner-URL",
  "custom_range": "Benutzerdefinierter Bereich",
  "daily_budget": "Tagesbudget",
  "daily_performance": "Tägliche Performance",
  "dark_mode": "Dunkler Modus",
  "data_viz_title": "Datenvisualisierung",
  "date": "Datum",
  "dating_add_video": "Füge ein kurzes Video hinzu, damit potenzielle Matches dich besser kennenlernen können",
  "dating_block": "Blockieren",
  "dating_boosts": "Boosts",
  "dating_city": "Stadt",
  "dating_next": "Weiter",
  "dating_personality_quiz": "Persönlichkeitstest",
  "dating_quiz_completed": "Persönlichkeitstest abgeschlossen",
  "dating_users": "Benutzer",
  "dating_verify_identity": "Verifizieren Sie, dass Sie eine echte Person sind",
  "dating_voice_message": "Sprachnachricht",
  "days": "Tage",
  "delete": "Loschen",
  "delete_failed": "Löschen fehlgeschlagen.",
  "deleted_successfully": "Erfolgreich gelöscht",
  "deprecated": "Veraltet",
  "describe_thumbnail": "Beschreiben Sie das Miniaturbild zur Erstellung...",
  "description": "Beschreibung",
  "deselect_all": "Alle abwählen",
  "desktop": "Desktop",
  "details": "Details",
  "dimensions": "Abmessungen",
  "disabled": "Deaktiviert",
  "dismiss": "Verwerfen",
  "documentation": "Dokumentation",
  "doktor_add_document": "Dokument hinzufügen",
  "doktor_biography": "Biografie",
  "doktor_birth_date": "Geburtsdatum",
  "doktor_chat": "Chat",
  "doktor_control_date": "Kontrolldatum",
  "doktor_date": "Datum",
  "doktor_diagnosis": "Diagnose",
  "doktor_enter_name_specialization": "Geben Sie den Namen und mindestens eine Spezialisierung ein",
  "doktor_enter_patient_name": "Patientennamen eingeben",
  "doktor_license_number": "Lizenznummer",
  "doktor_panel": "Ärztepanel",
  "doktor_patient_name": "Patientenname",
  "doktor_text_min_chars": "Text muss mindestens 50 Zeichen haben",
  "doktor_waiting_room": "Wartezimmer",
  "dont_have_account": "Kein Konto?",
  "download": "Herunterladen",
  "draft": "Entwurf",
  "duplicate": "Duplizieren",
  "duration_days": "Dauer (Tage)",
  "economy": "Wirtschaft",
  "edit": "Bearbeiten",
  "electronics": "Elektronik",
  "email": "E-Mail",
  "email_address": "E-Mail-Adresse",
  "email_campaigns": "E-Mail-Kampagnen",
  "email_clicks": "E-Mail Klicks",
  "email_content": "E-Mail-Inhalt...",
  "email_opens": "E-Mail Offnungen",
  "email_placeholder": "Ihre E-Mail Adresse",
  "email_subject": "E-Mail-Betreff",
  "employer": "Arbeitgeber",
  "enabled": "Aktiviert",
  "end_date": "Enddatum",
  "enter_advertiser_email": "Geben Sie Ihre Werbetreibenden-E-Mail ein...",
  "enter_email_to_view": "Geben Sie Ihre Werbetreibenden-E-Mail oben ein, um die Kampagnenleistung anzuzeigen",
  "entertainment": "Unterhaltung",
  "error": "Fehler",
  "error_deleting": "Fehler beim Löschen",
  "error_generating_digest": "Fehler beim Erstellen der Zusammenfassung",
  "error_loading": "Fehler beim Laden",
  "error_saving": "Fehler beim Speichern",
  "error_saving_settings": "Fehler beim Speichern",
  "error_sending": "Fehler beim Senden",
  "error_uploading": "Fehler beim Hochladen",
  "error_uploading_photo": "Hochladen des Fotos fehlgeschlagen",
  "events_calendar": "Veranstaltungskalender",
  "excerpt_summary": "Auszug / Zusammenfassung",
  "experimental": "Experimentell",
  "export": "Exportieren",
  "export_data": "Daten exportieren",
  "facebook": "Facebook",
  "facebook_login_unavailable": "Facebook-Anmeldung nicht verfügbar",
  "failed_post_comment": "Kommentar konnte nicht gepostet werden.",
  "feature_flags": "Feature-Flags",
  "feature_job": "Job hervorheben",
  "featured": "Empfohlen",
  "featured_article": "Hauptartikel",
  "featured_duration": "Dauer der Hervorhebung",
  "featured_image": "Hauptbild",
  "featured_jobs": "Empfohlene Stellen",
  "feedback": "Feedback",
  "filter": "Filter",
  "filter_terms_saved": "Filterbegriffe gespeichert!",
  "find_jobs": "Stellenangebote finden",
  "first": "Erste",
  "first_process_publish": "Zuerst den Artikel verarbeiten und veröffentlichen",
  "footer_ai": "Dieses Portal nutzt KI-Unterstutzung",
  "footer_ai_notice": "Einige Inhalte mit KI-Unterstützung erstellt - Probleme melden",
  "footer_cat_business": "Wirtschaft",
  "footer_cat_culture": "Kultur",
  "footer_cat_health": "Gesundheit",
  "footer_cat_news": "Nachrichten",
  "footer_cat_politics": "Politik",
  "footer_cat_sports": "Sport",
  "footer_cat_technology": "Technologie",
  "footer_categories": "Kategorien",
  "footer_copyright": "2026 Liber Nostra d.o.o. Alle Rechte vorbehalten.",
  "footer_description": "Croatia Times ist Ihre vertrauenswürdige Quelle für aktuelle Nachrichten, tiefgehende Analysen und fesselnde Geschichten aus Kroatien und darüber hinaus.",
  "footer_developed_by": "Entwickelt und gepflegt mit Liebe von",
  "footer_email_placeholder": "Ihre E-Mail-Adresse",
  "footer_here": "hier",
  "footer_hosted_by": "Gehostet von",
  "footer_link_about": "Über uns",
  "footer_link_advertise": "Werben",
  "footer_link_contact": "Kontakt",
  "footer_link_cookies": "Cookies",
  "footer_link_imprint": "Impressum",
  "footer_link_privacy": "Datenschutzrichtlinie",
  "footer_link_submit_news": "Nachrichten einreichen",
  "footer_newsletter_text": "Abonnieren Sie unseren Newsletter",
  "footer_quick_links": "Schnellzugriff",
  "footer_stay_informed": "Bleiben Sie informiert",
  "footer_subscribe": "Abonnieren",
  "for_you_personalized": "Personalisierte Inhalte basierend auf Ihren Interessen",
  "for_you_title": "Für Dich",
  "forgot_password": "Passwort vergessen?",
  "free": "Kostenlos",
  "free_plan": "Kostenlos",
  "from": "Von",
  "full_time": "Vollzeit",
  "general": "Allgemein",
  "goodbye": "Auf Wiedersehen",
  "hashtags": "Hashtags",
  "hashtags_placeholder": "#nachrichten #croatia...",
  "header_auto_schedule_active": "Automatischer Zeitplan aktiv",
  "header_forecast": "Vorhersage",
  "header_humidity": "Luftfeuchtigkeit",
  "header_live": "LIVE",
  "header_portals_label": "Portale",
  "header_weather_humidity": "Luftfeuchtigkeit",
  "header_weather_wind": "Wind",
  "header_wind": "Wind",
  "health": "Gesundheit",
  "hello": "Hallo",
  "help": "Hilfe",
  "home": "Startseite",
  "home_podcast_title": "Wöchentliche Tech-Zusammenfassung: KI in kroatischen Startups",
  "home_video_title": "Inside Zagreb: Street Art Dokumentation",
  "hours": "Stunden",
  "import": "Importieren",
  "impressions": "Einblendungen",
  "imprint": "Impressum",
  "imprint_title": "Impressum",
  "inactive": "Inaktiv",
  "info": "Info",
  "instagram": "Instagram",
  "invalid_code": "Ungültiger Code. Versuchen Sie es erneut.",
  "items_selected": "Elemente ausgewählt",
  "job_categories": "Jobkategorien",
  "job_postings": "Stellenanzeigen",
  "job_seeker": "Arbeitssuchende",
  "jobs": "Stellenangebote",
  "just_now": "Gerade eben",
  "language": "Sprache",
  "last": "Letzte",
  "latest_news": "Neueste Nachrichten",
  "legal": "Rechtliches",
  "lifestyle": "Lebensstil",
  "lifetime": "Lebensdauer",
  "light_mode": "Heller Modus",
  "linked_email_campaign": "Mit E-Mail-Kampagne verknüpft",
  "linkedin": "LinkedIn",
  "live_stream": "Live-Übertragung",
  "load_more": "Mehr laden",
  "loading": "Laden...",
  "local": "Lokal",
  "location": "Standort",
  "login": "Anmelden",
  "logout": "Abmelden",
  "loyalty_available_points": "Verfügbare Punkte",
  "loyalty_available_rewards": "Verfügbare Belohnungen",
  "loyalty_badges": "Abzeichen",
  "loyalty_consecutive_days": "Aufeinanderfolgende Tage",
  "loyalty_error": "Fehler",
  "loyalty_leaderboard": "Rangliste",
  "loyalty_leaderboard_empty": "Rangliste ist leer",
  "loyalty_rewards": "Belohnungen",
  "loyalty_used_rewards": "Verwendete Belohnungen",
  "majstor_categories": "Kategorien",
  "majstor_city": "Stadt",
  "majstor_company_name": "Firmenname *",
  "majstor_flexible": "Flexibel",
  "majstor_max_budget": "Max Budget (EUR)",
  "majstor_min_budget": "Min Budget (EUR)",
  "majstor_my_requests": "Meine Anfragen",
  "majstor_request_title": "Anfragetitel *",
  "majstor_service_categories": "Dienstkategorien",
  "majstor_urgent": "Dringend",
  "manage": "Verwalten",
  "manage_bookings": "Verwalten Sie die Buchungen der Werbetreibenden",
  "mark_as_read": "Als gelesen markieren",
  "marketing_dashboard": "Marketing-Dashboard",
  "marketing_live_metrics": "Live-Leistungskennzahlen für Croatia Times",
  "marketing_published_articles": "Veröffentlichte Artikel",
  "marketing_registered_users": "Registrierte Benutzer",
  "marketing_today_views": "Heutige Aufrufe",
  "marketing_total_views": "Gesamtanzahl Seitenaufrufe",
  "minutes": "Minuten",
  "missing_translations": "Fehlende Übersetzungen",
  "mobile": "Mobil",
  "more": "Mehr",
  "most_popular": "Beliebteste",
  "most_read": "Am meisten gelesen",
  "move": "Verschieben",
  "must_be_logged_in_purchase": "Sie müssen angemeldet sein, um einen Artikel zu kaufen",
  "myProfile": "Mein Profil",
  "my_applications": "Meine Bewerbungen",
  "name": "Name",
  "new": "Neu",
  "new_article": "Neuer Artikel",
  "new_campaign": "Neue Kampagne",
  "new_notification": "Neue Benachrichtigung",
  "new_push_notification": "Neue Push-Benachrichtigung",
  "new_verification_sent": "Ein neuer Bestätigungscode wurde an Ihre E-Mail gesendet.",
  "news": "Nachrichten",
  "newsletter": "Newsletter",
  "newsletter_desc": "Abonnieren Sie die neuesten Nachrichten",
  "newsletter_only_subscribers": "Nur Abonnenten",
  "newsletter_subscribers": "Newsletter-Abonnenten",
  "next": "Weiter",
  "no": "Nein",
  "noAccount": "Noch kein Konto?",
  "no_articles": "Keine Artikel gefunden",
  "no_bookings": "Keine Buchungen gefunden",
  "no_campaigns": "Keine Kampagnen",
  "no_data": "Keine Daten verfügbar",
  "no_items": "Keine Einträge gefunden",
  "no_linked_campaign": "Keine verknüpfte Kampagne",
  "no_notifications": "Keine Benachrichtigungen",
  "no_results": "Keine Ergebnisse",
  "no_scheduled_posts": "Noch keine geplanten Beiträge",
  "no_sent_notifications": "Keine gesendeten Benachrichtigungen",
  "none": "Keine",
  "note": "Hinweis",
  "notification_body": "Benachrichtigungstext",
  "notification_title": "Benachrichtigungstitel",
  "notifications": "Benachrichtigungen",
  "of": "von",
  "off": "Aus",
  "offline": "Offline",
  "on": "An",
  "one_time": "einmalig",
  "online": "Online",
  "open_rate": "Offnungsrate",
  "optional": "Optional",
  "options": "Optionen",
  "orContinueWith": "Oder weiter mit",
  "or_continue_with": "Oder weiter mit",
  "order": "Bestellung",
  "other": "Andere",
  "page": "Seite",
  "part_time": "Teilzeit",
  "password": "Passwort",
  "paste": "Einfügen",
  "pause": "Pausieren",
  "payment_error": "Zahlungsfehler",
  "payment_processing": "Zahlung wird verarbeitet...",
  "payment_success": "Zahlung erfolgreich!",
  "payment_thank_you": "Vielen Dank für Ihren Kauf!",
  "pending": "Ausstehend",
  "pending_approval": "Ausstehende Genehmigung",
  "per_month": "/Mo",
  "per_page": "pro Seite",
  "percentage": "Prozentsatz",
  "performance": "Leistung",
  "phone": "Telefon",
  "platforms": "Plattformen",
  "politics": "Politik",
  "poll_results": "Ergebnisse",
  "poll_total_votes": "Gesamtstimmen",
  "poll_vote": "Abstimmen",
  "popular": "Beliebt",
  "post_comment": "Kommentar posten",
  "post_error": "Beitragsfehler",
  "post_job": "Stelle ausschreiben",
  "post_now": "Jetzt posten",
  "powered_by": "Bereitgestellt von",
  "premium": "Premium",
  "preview": "Vorschau",
  "previous": "Zuruck",
  "price": "Preis",
  "privacy": "Datenschutz",
  "privacy_title": "Datenschutzerklärung",
  "proceed_to_payment": "Weiter zur Zahlung",
  "profile": "Profil",
  "profile_admin_access": "Schnellzugriff für Admins",
  "profile_analytics": "Analysen",
  "profile_articles": "Artikel",
  "profile_dashboard": "Dashboard",
  "profile_edit": "Profil bearbeiten",
  "profile_verified": "Profil verifiziert!",
  "promo_success": "Promo-Code erfolgreich angewendet!",
  "promote_job": "Job bewerben",
  "publish": "Veröffentlichen",
  "published": "Veroffentlicht",
  "published_date": "Veröffentlicht",
  "push_notifications": "Push-Benachrichtigungen",
  "read": "Gelesen",
  "read_more": "Weiterlesen",
  "real_estate": "Immobilien",
  "recent": "Neueste",
  "recipes_add_first": "Füge dein erstes Rezept hinzu",
  "recipes_browse_all": "Alle Rezepte durchsuchen",
  "recipes_category": "Kategorie",
  "recipes_cook_time": "Kochzeit",
  "recipes_easy": "Einfach",
  "recipes_featured": "Empfohlene Rezepte",
  "recipes_filters": "Filter",
  "recipes_ingredient": "Zutat",
  "recipes_ingredients": "Zutaten",
  "recipes_instructions": "Anweisungen",
  "recipes_latest": "Neueste Rezepte",
  "recipes_most_popular": "Beliebteste Rezepte",
  "recipes_prep_time": "Vorbereitungszeit",
  "recipes_search": "Rezepte suchen...",
  "recipes_servings": "Portionen",
  "recipes_title": "Rezepte",
  "recommended": "Empfohlen",
  "refresh": "Aktualisieren",
  "region": "Region",
  "register": "Registrieren",
  "reject": "Ablehnen",
  "rejected": "Abgelehnt",
  "related_articles": "Verwandte Artikel",
  "remote": "Fernarbeit",
  "remove": "Entfernen",
  "report": "Bericht",
  "reports": "Berichte",
  "reposting_rules_title": "Regeln für das erneute Posten",
  "required": "Erforderlich",
  "reset": "Zurücksetzen",
  "restore": "Wiederherstellen",
  "results": "Ergebnisse",
  "resume": "Fortsetzen",
  "revision_restored": "Revision wiederhergestellt!",
  "salary": "Gehalt",
  "salary_max": "Maximales Gehalt",
  "salary_min": "Mindestgehalt",
  "save": "Speichern",
  "saved_jobs": "Gespeicherte Stellen",
  "saved_successfully": "Erfolgreich gespeichert",
  "schedule": "Zeitplan",
  "scheduled": "Geplant",
  "science": "Wissenschaft",
  "search": "Suchen...",
  "search_articles": "Artikel suchen...",
  "search_placeholder": "Suche...",
  "search_results_for": "Suchergebnisse für",
  "seconds": "Sekunden",
  "see_all": "Alle ansehen",
  "select": "Auswählen",
  "select_all": "Alle auswählen",
  "select_format": "Format auswählen",
  "seller": "Verkäufer",
  "send_campaign": "Kampagne senden",
  "sent": "Gesendet",
  "sent_campaigns": "Gesendete Kampagnen",
  "services": "Dienstleistungen",
  "settings": "Einstellungen",
  "share": "Teilen",
  "showing": "Anzeigen",
  "signIn": "Anmelden",
  "signOut": "Abmelden",
  "site_name": "Croatia Times",
  "site_subtitle": "Kroatien Heute",
  "six_digit_code": "6-stelliger Code",
  "social_media": "Soziale Medien",
  "social_scheduler": "Sozialer Zeitplaner",
  "sort": "Sortieren",
  "sponsored_marketplace_title": "Gesponserter Marktplatz",
  "sports": "Sport",
  "stable": "Stabil",
  "start": "Starten",
  "start_date": "Startdatum",
  "static_about_contact": "Für redaktionelle Anfragen, Werbung oder allgemeine Informationen besuchen Sie unsere",
  "static_about_contact_page": "Kontaktseite",
  "static_about_contact_title": "Kontakt",
  "static_about_lead": "Croatia Times ist ein unabhängiges Nachrichtenportal, das Ihnen die neuesten Nachrichten, Analysen, Kommentare und Geschichten aus Kroatien und der Region bringt. Wir sind Teil der e-mina.eu Medienfamilie, mit dem gleichen Team und den gleichen Werten.",
  "static_about_mission": "Wir sind bestrebt, genaue, zeitnahe und qualitativ hochwertige Journalistik zu liefern, die dem öffentlichen Interesse dient. Unser Redaktionsteam besteht aus erfahrenen Journalisten mit tiefem Wissen über kroatische und regionale Themen.",
  "static_about_mission_title": "Unsere Mission",
  "static_about_publisher": "Liber Nostra d.o.o. ist der Herausgeber von Croatia Times und e-mina.eu. Das Unternehmen spezialisiert sich auf digitale Medien und Nachrichtenportale, die sich auf den kroatischen Markt konzentrieren.",
  "static_about_publisher_title": "Herausgeber",
  "static_about_standards": "Croatia Times hält sich an die höchsten journalistischen Standards. Wir überprüfen die Fakten unserer Berichte, kennzeichnen Kommentare und Analysen klar und korrigieren Fehler unverzüglich und transparent.",
  "static_about_standards_title": "Redaktionsstandards",
  "static_about_team": "Hinter Croatia Times steht ein Team von erfahrenen Medienfachleuten, Journalisten, Redakteuren und technischen Experten, die an der Plattformentwicklung und der Inhaltsqualität arbeiten. Unser Team ist dasselbe, das hinter dem erfolgreichen Portal e-mina.eu - International News Agency steht.",
  "static_about_team_title": "Team",
  "static_about_title": "Über uns - Croatia Times",
  "static_bug_description": "Fehlerbeschreibung",
  "static_bug_description_placeholder": "Beschreiben Sie, was passiert ist und wie das Problem reproduziert werden kann...",
  "static_bug_intro": "Etwas gefunden, das nicht korrekt funktioniert? Lassen Sie es uns wissen, und wir werden es umgehend beheben.",
  "static_bug_page_url": "Seiten-URL (wo der Fehler aufgetreten ist)",
  "static_bug_screenshot": "Screenshot (optional)",
  "static_bug_submit": "Fehlerbericht einreichen",
  "static_bug_submitting": "Wird gesendet...",
  "static_bug_thanks": "Danke für Ihren Bericht! Wir werden das Problem untersuchen und beheben.",
  "static_bug_title": "Einen Fehler melden",
  "static_commenting_intro": "Wir begrüßen konstruktive Diskussionen. Um unseren Kommentarbereich positiv und produktiv zu halten, befolgen Sie bitte diese Regeln:",
  "static_commenting_login": "Um kommentieren zu können, müssen Sie bei Croatia Times registriert und angemeldet sein.",
  "static_commenting_rule_1": "Seien Sie respektvoll und höflich gegenüber anderen Nutzern und den Themen der Artikel",
  "static_commenting_rule_2": "Keine Hassrede, Rassismus, Sexismus oder Diskriminierung jeglicher Art",
  "static_commenting_rule_3": "Kein Spam, keine Werbung oder werbende Inhalte",
  "static_commenting_rule_4": "Keine Fehlinformationen oder Verbreitung unbestätigter Behauptungen",
  "static_commenting_rule_5": "Keine persönlichen Angriffe oder Belästigungen",
  "static_commenting_rule_6": "Bleiben Sie beim Thema und tragen Sie zur Diskussion bei",
  "static_commenting_rule_7": "Keine persönlichen oder vertraulichen Informationen über Dritte",
  "static_commenting_title": "Kommentarregeln",
  "static_commenting_violation": "Kommentare, die gegen diese Regeln verstoßen, können ohne Benachrichtigung entfernt werden. Wiederholungstäter können dauerhaft gesperrt werden.",
  "static_contact_email": "E-Mail",
  "static_contact_message": "Nachricht",
  "static_contact_message_placeholder": "Ihre Nachricht...",
  "static_contact_name": "Name",
  "static_contact_name_placeholder": "Ihr Name",
  "static_contact_send": "Nachricht senden",
  "static_contact_sending": "Senden...",
  "static_contact_sent_desc": "Wir werden uns innerhalb von 24 Stunden bei Ihnen melden.",
  "static_contact_sent_title": "Nachricht gesendet!",
  "static_contact_subject": "Betreff",
  "static_contact_subject_placeholder": "Wie können wir helfen?",
  "static_contact_title": "Kontaktieren Sie uns",
  "static_cookies_advertising_text": "Wir können Google AdSense-Cookies verwenden, um relevante Werbung zu schalten.",
  "static_cookies_advertising_title": "Werbe-Cookies",
  "static_cookies_analytics_text": "Google Analytics hilft uns zu verstehen, wie Besucher unsere Website nutzen. Daten werden, wenn möglich, anonymisiert.",
  "static_cookies_analytics_title": "Analyse-Cookies",
  "static_cookies_managing_text": "Sie können Cookies über Ihre Browsereinstellungen verwalten. Das Deaktivieren notwendiger Cookies kann die Funktionalität der Website beeinträchtigen.",
  "static_cookies_managing_title": "Verwaltung von Cookies",
  "static_cookies_necessary_text": "Diese sind erforderlich, damit die Website funktioniert (z.B. Anmeldesitzungen, Themenpräferenzen). Sie können nicht deaktiviert werden.",
  "static_cookies_necessary_title": "Notwendige Cookies",
  "static_cookies_title": "Cookie-Richtlinie",
  "static_cookies_types_title": "Arten von Cookies, die wir verwenden",
  "static_cookies_what_text": "Cookies sind kleine Textdateien, die auf Ihrem Gerät abgelegt werden, wenn Sie eine Website besuchen. Sie helfen der Website, sich Ihre Präferenzen zu merken und zu verstehen, wie Sie sie nutzen.",
  "static_cookies_what_title": "Was sind Cookies",
  "static_imprint_ads_email": "E-Mail (Werbung):",
  "static_imprint_ai_notice": "Einige Inhalte werden mit KI-Technologie generiert. Fehler oder unangemessene Inhalte melden an",
  "static_imprint_contact": "Kontakt",
  "static_imprint_copyright": "Urheberrecht",
  "static_imprint_copyright_text": "Alle auf Croatia Times veröffentlichten Inhalte sind urheberrechtlich geschützt. Liber Nostra d.o.o. behält alle Rechte an Texten, Bildern und multimedialen Inhalten, die auf dieser Website veröffentlicht werden. Detaillierte Informationen zu den Regeln für die Wiederveröffentlichung von Inhalten finden Sie auf der",
  "static_imprint_ct_desc": "Nachrichtenportal Croatia Times",
  "static_imprint_disclaimer": "Haftungsausschluss",
  "static_imprint_disclaimer_text": "Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für externe Links. Für deren Inhalt sind ausschließlich deren Betreiber verantwortlich.",
  "static_imprint_editorial_email": "E-Mail (Redaktion):",
  "static_imprint_emina_desc": "Internationale Nachrichtenagentur",
  "static_imprint_general_email": "E-Mail (allgemeine Anfragen):",
  "static_imprint_last_updated": "Zuletzt aktualisiert: Februar 2026",
  "static_imprint_or_via": "oder über unsere",
  "static_imprint_publisher": "Herausgeber",
  "static_imprint_registered": "Eingetragen in der Republik Kroatien",
  "static_imprint_reposting_page": "Seite mit Wiederveröffentlichungsregeln",
  "static_imprint_responsible": "Verantwortlich für den Inhalt",
  "static_imprint_responsible_text": "Redaktionsteam von Croatia Times / Liber Nostra d.o.o.",
  "static_imprint_title": "Impressum",
  "static_imprint_websites": "Websites",
  "static_privacy_controller": "Datenverantwortlicher: Liber Nostra d.o.o.",
  "static_privacy_cookies_text": "Wir verwenden Cookies für Funktionalität und Analysen. Siehe unsere Cookie-Richtlinie für Details.",
  "static_privacy_cookies_title": "Cookies",
  "static_privacy_data_text": "Wir erfassen Daten, die Sie direkt angeben (Name, E-Mail bei der Anmeldung), Nutzungsdaten (besuchte Seiten, gelesene Artikel) und technische Daten (IP-Adresse, Browsertyp).",
  "static_privacy_data_title": "Daten, die wir sammeln",
  "static_privacy_last_updated": "Zuletzt aktualisiert: Januar 2026",
  "static_privacy_lead": "Croatia Times respektiert Ihre Privatsphäre und ist dem Schutz Ihrer persönlichen Daten verpflichtet.",
  "static_privacy_retention_text": "Wir speichern Ihre Daten, solange Ihr Konto aktiv ist oder wie für rechtliche Zwecke erforderlich.",
  "static_privacy_retention_title": "Datenaufbewahrung",
  "static_privacy_rights_text": "Sie haben das Recht, auf Ihre persönlichen Daten zuzugreifen, sie zu korrigieren oder zu löschen. Kontaktieren Sie uns unter",
  "static_privacy_rights_title": "Ihre Rechte",
  "static_privacy_title": "Datenschutzrichtlinie",
  "static_privacy_usage_text": "Wir verwenden Ihre Daten, um unseren Nachrichtendienst bereitzustellen, Ihre Erfahrung zu personalisieren, Newsletter zu senden (mit Ihrer Zustimmung) und unsere Plattform zu verbessern.",
  "static_privacy_usage_title": "Wie wir Ihre Daten verwenden",
  "static_reposting_copyright_text": "Alle auf Croatia Times veröffentlichten Inhalte sind urheberrechtlich geschützt. Liber Nostra d.o.o. behält sich alle Rechte an den auf dieser Website veröffentlichten Texten, Bildern und Multimedia vor.",
  "static_reposting_copyright_title": "Urheberrecht",
  "static_reposting_permission_text": "Für eine Genehmigung zum Nachdrucken von Inhalten kontaktieren Sie uns unter",
  "static_reposting_permission_title": "Genehmigungsanfragen",
  "static_reposting_permitted_text": "Sie dürfen Links zu unseren Artikeln in sozialen Medien und anderen Plattformen teilen. Kurze Zitate (bis zu 2 Absätze) dürfen mit klarer Quellenangabe und einem Link zum Originalartikel verwendet werden.",
  "static_reposting_permitted_title": "Zulässige Nutzung",
  "static_reposting_prohibited_text": "Das vollständige Nachdrucken von Artikeln ohne schriftliche Genehmigung ist verboten. Bilder dürfen ohne Erlaubnis nicht reproduziert werden. Automatisiertes Scraping von Inhalten ist strengstens untersagt.",
  "static_reposting_prohibited_title": "Verbotene Nutzung",
  "static_reposting_title": "Regeln für das Wiedereinstellen",
  "static_submit_news_details": "Geschichtsdetails",
  "static_submit_news_details_placeholder": "Beschreiben Sie die Nachrichten...",
  "static_submit_news_file_limit_error": "Datei überschreitet das Limit von",
  "static_submit_news_headline": "Nachrichtenschlagzeile",
  "static_submit_news_intro": "Haben Sie Nachrichten? Senden Sie sie hier und unser Redaktionsteam wird sie prüfen.",
  "static_submit_news_limit": "Wir akzeptieren Fotos und Videos bis zu",
  "static_submit_news_photos": "Fotos / Video (bis zu",
  "static_submit_news_send": "Nachrichten einsenden",
  "static_submit_news_sending": "Wird gesendet...",
  "static_submit_news_source": "Quelle / Referenz (optional)",
  "static_submit_news_source_placeholder": "URL oder Referenz",
  "static_submit_news_thanks": "Vielen Dank für Ihre Einsendung! Unser Team wird diese in Kürze prüfen.",
  "static_submit_news_title": "Reichen Sie Ihre Nachrichten ein",
  "static_submit_news_your_name": "Ihr Name",
  "status": "Status",
  "stop": "Stoppen",
  "submit": "Absenden",
  "submitNews": "Nachrichten einreichen",
  "submit_bug_title": "Fehlerbericht einreichen",
  "submit_news": "Nachricht senden",
  "submit_news_title": "Nachrichten einreichen",
  "subscribe": "Abonnieren",
  "subscription": "Abonnement",
  "subscription_title": "Abonnementpläne",
  "success": "Erfolg",
  "support": "Unterstützung",
  "tablet": "Tablet",
  "tags": "Tags",
  "target_impressions": "Ziel-Impressionen",
  "technology": "Technologie",
  "template": "Vorlage",
  "templates": "Vorlagen",
  "terms": "Bedingungen",
  "thank_you": "Danke",
  "this_month": "Diesen Monat",
  "this_week": "Diese Woche",
  "this_year": "Dieses Jahr",
  "tip": "Tipp",
  "title": "Titel",
  "to": "Bis",
  "today": "Heute",
  "total": "Gesamt",
  "translate_all": "Alle übersetzen",
  "translation_status": "Übersetzungsstatus",
  "translations": "Übersetzungen",
  "travel": "Reise",
  "trending": "Im Trend",
  "try_again": "Erneut versuchen",
  "twitter": "Twitter",
  "two_factor_auth": "Zwei-Faktor-Authentifizierung",
  "type": "Typ",
  "ugc_submit": "Inhalt einreichen",
  "ugc_title": "Bürgerjournalismus-Portal",
  "unique_clicks": "Eindeutige Klicks",
  "unique_opens": "Eindeutige Öffnungen",
  "unknown": "Unbekannt",
  "unpublish": "Zurückziehen",
  "unread": "Ungelesen",
  "update": "Aktualisieren",
  "updated_successfully": "Erfolgreich aktualisiert",
  "upgrade": "Upgrade",
  "upload": "Hochladen",
  "users": "Benutzer",
  "vehicles": "Fahrzeuge",
  "verification_code_sent": "Bestätigungscode an Ihre E-Mail gesendet!",
  "version": "Version",
  "vibeposao": "Times Posao",
  "view": "Ansicht",
  "view_all": "Alle ansehen",
  "views": "Aufrufe",
  "warning": "Warnung",
  "welcome": "Willkommen",
  "wish_roles": "Wunschstellen",
  "working_hours_saved": "Arbeitszeiten gespeichert!",
  "world": "Welt",
  "write_new_article": "Neuen Artikel schreiben",
  "yes": "Ja",
  "yesterday": "Gestern",
  "your_bookings": "Ihre Buchungen",
  "youtube": "YouTube"
}
